<template>
    <div :class="clContainer()">
        <div :class="clSub('date')">
            <small>{{ message.trigger_user.name }}, {{ dateOutput(message.created_at) }}</small>
        </div>

        <div :class="clSub('body')">
            <div v-if="message.data.pictures || message.context_info.part" :class="clSub('info')">
                <div v-if="message.context_info.part">{{ message.context_info.part.name }}</div>

                <img v-if="message.data.pictures" :src="icon('camera.svg')" />
            </div>

            <div :class="clSub('text')">
                <h2>{{ __(`messages.jobs.common.${message.sourceTypeName}.title`) }}</h2>

                <div v-tif="{ path: `messages.jobs.common.${message.sourceTypeName}.introtext`, args: message }"></div>

                <div v-if="message.context_info.fitting" class="mb-xs">
                    <job-fitting :fitting="message.context_info.fitting" class="card--white"></job-fitting>
                </div>
                <div v-else-if="message.data.rating">
                    <job-rating-display :rating="message.data.rating" :show-terms="false" :show-message="false" :icon-src="icon" class="mt-mdsm"></job-rating-display>
                </div>
                <p v-else-if="message.data.reason">
                    <span>{{ __('jobs.components.messages.common.labels.reason') }}</span> {{ message.data.reason.reason }}
                </p>

                <template v-if="message.data.text">
                    <div v-tif="`messages.jobs.common.${message.sourceTypeName}.text_label`"></div>
                    <div v-html="message.data.text"></div>
                </template>

                <template v-if="message.data.additionalText">
                    <p v-for="(text, index) in message.data.additionalText" :key="index" v-html="text"></p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import JobMessage from './JobMessage';
import JobFitting from 'smartdoors-shared/js/components/Jobs/JobFitting';

export default {
    extends: JobMessage,
    components: {
        'job-fitting': JobFitting
    },
}
</script>